import './SlideIndicators.css';

interface SlideIndicatorsProps {
	totalSlides: number;
	currentSlide: number;
	onSlideChange: (index: number) => void;
}

const SlideIndicators = ({ totalSlides, currentSlide, onSlideChange }: SlideIndicatorsProps) => {
	return (
		<section id="slide-indicators">
			{Array(totalSlides)
				.fill({})
				.map((s, i) => (
					<button key={s.id + i} className={`indicator ${i === currentSlide ? 'selected' : ''}`} onClick={() => onSlideChange(i)} />
				))}
		</section>
	);
};

export default SlideIndicators;
